import { render } from "./BasedataAdmin.vue?vue&type=template&id=f0f72e9c"
import script from "./BasedataAdmin.vue?vue&type=script&lang=js"
export * from "./BasedataAdmin.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./BasedataAdmin.vue?vue&type=style&index=0&id=f0f72e9c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script